import client from '../client';
import type { ApiResponse } from '../../types/api';

// Generic, provider-agnostic app-fulfillment types. A "provider" is an installed
// sourcing app; each declares the buyer-input fields it needs (uid, region, ...)
// via `inputs`, so the UI stays generic instead of hardcoding any one supplier.

export interface FulfillmentProviderInput {
  key: string;
  label: string;
  required: boolean;
}

export interface FulfillmentProvider {
  installationId: string;
  appId: string;
  appSlug: string;
  appName: string;
  productType?: string;
  inputs: FulfillmentProviderInput[];
  hasCatalog: boolean;
}

export interface FulfillmentCatalogProduct {
  external_id: string;
  internal_id?: string;
  title?: string;
  name?: string;
  namedPrice?: number;
  suggestedPrice?: number;
  cost?: number;
}

export interface FulfillmentCatalogCategory {
  title: string;
  products: FulfillmentCatalogProduct[];
}

export interface FulfillmentCatalog {
  currency: string;
  categories: FulfillmentCatalogCategory[];
}

export const fulfillmentApi = {
  /** Installed sourcing apps that can fulfill products for this store. */
  providers: async (storeId: string): Promise<FulfillmentProvider[]> => {
    const res = await client.get<ApiResponse<{ providers: FulfillmentProvider[] }>>(
      `/dashboard/${storeId}/fulfillment/providers`,
    );
    return res.data.data?.providers ?? [];
  },

  /** The provider's SKU catalog, grouped into categories. */
  catalog: async (storeId: string, installationId: string): Promise<FulfillmentCatalog> => {
    const res = await client.get<ApiResponse<FulfillmentCatalog>>(
      `/dashboard/${storeId}/fulfillment/${installationId}/catalog`,
    );
    return res.data.data!;
  },
};
